document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll(
    '.featured-collection-slider__products, .featured-collection-grid__products'
  );

  sliders.forEach((slider) => {
    const sectionId = slider.getAttribute('data-section-id');
    const productScript = document.getElementById(`products-${sectionId}`);
    if (!productScript) return;
    let products = [];

    try {
      products = JSON.parse(productScript.textContent);
    } catch (e) {
      console.warn(`Invalid JSON in products-${sectionId}`, e);
    }
    updateSliderCurrency(products, slider);
  });
});

const updateSliderCurrency = async (products, sliderElement) => {
  for (let productItem of products) {
    const displayAmount = await convertCurrencyByCountry(productItem, sliderElement);
    const matchingPriceElements = sliderElement.querySelectorAll(
      `[data-handle="${productItem.handle}"][data-id="${productItem.id}"]`
    );

    matchingPriceElements.forEach((el) => {
      el.innerText = displayAmount;
    });
  }
};
